<template>
  <div>
    <v-snackbar
      :timeout="-1"
      :value="event === 'app-updated'"
      :width="600"
      multi-line
      @click="reload(); resetEvent()"
    >
      <v-icon class="mr-3">fal fa-circle-exclamation</v-icon>
      <div class="text-subtitle-1 mr-5">{{ $t('A new version of the software is available.') }}</div>
      <v-btn
        color="primary"
        @click="reload(); resetEvent()"
      >{{ $t('Reload').toUpperCase() }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import cashRegistersService from '@/services/cash-registers'
export default {
  name: 'ServiceWorker',

  data: () => ({
    event: null
  }),

  mounted () {
    this.register()
    this.listenForEvents()
  },

  methods: {
    listenForEvents () {
      const channel = new BroadcastChannel('sw-messages')
      channel.addEventListener('message', payload => {
        const data = payload.data
        this.event = data.event
      })
    },
    register () {
      if ('Notification' in window) {
        // Ask for permission first time
        if (Notification.permission !== 'granted') {
          Notification.requestPermission().then(permission => {
            if (permission === 'granted' && 'serviceWorker' in navigator) {
              navigator.serviceWorker.register('/sw.js').then(this.saveEndpoint)
            }
          })
        }

        // User already gave permission
        if (Notification.permission === 'granted') {
          if (typeof (navigator.serviceworker) === 'undefined') return
          navigator.serviceWorker.ready.then(reg => {
            reg.pushManager.getSubscription()
          })
        }
      }
    },
    reload () {
      // Reloads the current page from the server, append timestamp
      window.location = `${window.location.href.split('?')[0]}?${Date.now()}`
    },
    resetEvent () {
      this.event = null
    },
    saveEndpoint () {
      if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
        console.warn('Notifications are not supported')
        return
      }

      if (Notification.permission === 'denied') {
        console.warn('User has blocked the notification')
        return
      }

      if (!('PushManager' in window)) {
        console.warn('Push messaging is not supported')
        return
      }

      // Do the subscription
      navigator.serviceWorker.ready.then(reg => {
        reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array('BEIv-X--rYaxPldHa-j1E8F9jOCn2GjnFo0oMd2otwsyl-Yu1qpDB-Ll45edbakEsaqnmf4rDGHvxNMHQcB88e8')
        }).then(sub => {
          const object = JSON.parse(JSON.stringify(sub))
          cashRegistersService.saveEndpoint(this.$store.state.identifier, object)
            .catch(data => {
              if (data && data.data.message) this.helpers.toastError(data.data.message)
            })
        })
      })
    },
    urlBase64ToUint8Array (base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4)
      const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
      const rawData = window.atob(base64)
      const outputArray = new Uint8Array(rawData.length)

      for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }
      return outputArray
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ServiceWorker.vue